
import React from "react"
import './OptionalTag.scss'

export const OptionalTag = (props) => {
    return (
        <div className={`text-small ${!props.colors ? `box` : props.colors} ${props.className}`}>optional</div>
    )
}